<div class="w-full relative min-h-[200px] h-full" *ngIf="data && data.datasets && data.datasets[0].data.length > 0; else emptyState">
  <p-chart type="line" [data]="data" [options]="options" height="100%"></p-chart>
</div>

<ng-template #emptyState>
  <div class="flex flex-col items-center justify-center w-full h-[200px] bg-gray-50 rounded-lg border border-dashed border-gray-200">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" class="text-gray-400 mb-2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
      </svg>
      <span class="text-sm font-medium text-gray-500">Not enough data to display graph.</span>
  </div>
</ng-template>
